<interview-wrapper [title]="'interviews.Practice Complete' | translate" class="practice-complete-wrapper">
    <div step-content>
        <div>{{'interviews.Practice Complete Instructions' | translate}}</div>
        <div class="space-top-md space-bottom-md">
            <div class="practice-action">
                <button type="button" class="btn btn_link inline-flexbox align-items-center no-padding-x" [routerLink]="['../review']" [queryParams]="{ attempt_id: attemptId, practice: true }">
                    <i class="icn icn-clock"></i> {{'interviews.Replay Practice Response' | translate}}
                </button>
            </div>
            <div class="practice-action">
                <button type="button" class="btn btn_link inline-flexbox align-items-center no-padding-x" [routerLink]="['../create']" [queryParams]="{ attempt_id: attemptId, practice: true }">
                    <i class="icn icn-refresh"></i> {{'interviews.Restart Practice Response' | translate}}
                </button>
            </div>
            <div class="practice-action">
                <button type="button" class="btn btn_link inline-flexbox align-items-center no-padding-x" [routerLink]="['../settings']">
                    <i class="icn icn-gear"></i> {{'interviews.Change Settings' | translate}}
                </button>
            </div>
        </div>
    </div>
    <div step-actions>
        <button type="button" [routerLink]="['../begin']" class="btn btn_primary">{{'interviews.Start Interview' | translate}}</button>
    </div>
</interview-wrapper>
